import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetPerformanceReportForProfessionalsTopValidatedActivitiesUseCaseInterface } from 'domain/usecases';

type TopValidatedActivitiesApiResponse = {
  data?: GetPerformanceReportForProfessionalsTopValidatedActivitiesUseCaseInterface.Result;
};

export class RemoteGetPerformanceReportForProfessionalsTopValidatedActivities
  implements
    GetPerformanceReportForProfessionalsTopValidatedActivitiesUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<TopValidatedActivitiesApiResponse>,
  ) {}

  async execute(
    params: GetPerformanceReportForProfessionalsTopValidatedActivitiesUseCaseInterface.Params,
  ): Promise<GetPerformanceReportForProfessionalsTopValidatedActivitiesUseCaseInterface.Result> {
    const requestUrl = generateUrl(this.url, {
      ...params,
      limit: params.limit || 10,
    } as any);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body?.data || [];
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
